'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement, Children, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FilePropTypes } from 'DesignData/propTypes/finder';
import { omit } from 'underscore';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import UIFormControl from 'UIComponents/form/UIFormControl';
import withFilenameValidation from 'DesignComponents/decorators/withFilenameValidation';
const propsNotUsedInRender = ['children', 'errorType', 'excludeExtension', 'fileType', 'initialValue', 'onChange', 'onError', 'onSuccess', 'showValidationNotification', 'validateDefaultValue', 'isServerlessPath'];

class ValidatedFilenameControl extends PureComponent {
  constructor(...args) {
    super(...args);

    this.validateChildInput = () => {
      const {
        onChange
      } = this.props;
      const {
        value,
        defaultValue
      } = this.childInput.props;
      const childValue = value || defaultValue || '';
      onChange(SyntheticEvent(childValue));
    };

    this.handleChange = evt => {
      const {
        onChange
      } = this.props;
      const {
        onChange: childOnChange
      } = this.childInput.props;
      onChange(evt);

      if (childOnChange) {
        childOnChange(evt);
      }
    };
  }

  componentDidMount() {
    const {
      validateDefaultValue
    } = this.props;

    if (validateDefaultValue) {
      this.validateChildInput();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      fileType,
      validateDefaultValue
    } = this.props;

    if (validateDefaultValue && fileType !== prevProps.fileType) {
      this.validateChildInput();
    }
  }

  get childInput() {
    const {
      children
    } = this.props;
    return Children.only(children);
  }

  renderChildInput() {
    return /*#__PURE__*/cloneElement(this.childInput, {
      onChange: this.handleChange
    });
  }

  render() {
    const _omit = omit(this.props, propsNotUsedInRender),
          {
      error,
      validationMessage
    } = _omit,
          rest = _objectWithoutPropertiesLoose(_omit, ["error", "validationMessage"]);

    return /*#__PURE__*/_jsx(UIFormControl, Object.assign({}, rest, {
      error: error,
      validationMessage: validationMessage,
      children: this.renderChildInput()
    }));
  }

}

ValidatedFilenameControl.propTypes = {
  children: PropTypes.node.isRequired,
  error: PropTypes.bool,
  errorType: PropTypes.string,
  excludeExtension: PropTypes.bool,
  fileType: FilePropTypes.fileType,
  initialValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func,
  onSuccess: PropTypes.func,
  showValidationNotification: PropTypes.func.isRequired,
  validateDefaultValue: PropTypes.bool.isRequired,
  validationMessage: PropTypes.node
};
ValidatedFilenameControl.defaultProps = {
  error: false,
  validateDefaultValue: true
};
export default withFilenameValidation()(ValidatedFilenameControl);